class CartItemSubscription extends HTMLElement {
  connectedCallback() {
    this.lineIndex = parseInt(this.dataset.lineIndex);
    this.quantity = parseInt(this.dataset.quantity);
    this.addEventListener('click', this.handleClick.bind(this));
    this._boundClose = this.onDocumentClick.bind(this);
    document.addEventListener('click', this._boundClose);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._boundClose);
  }

  handleClick(e) {
    var cta = e.target.closest('.cart-item__subscribe-cta');
    if (cta) {
      e.preventDefault();
      e.stopPropagation();
      this.changeSellingPlan(cta.dataset.planId);
      return;
    }

    var trigger = e.target.closest('.cart-item__subscription-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown();
      return;
    }

    var option = e.target.closest('[data-plan-id]');
    if (option && option.closest('cart-item-subscription') === this) {
      e.preventDefault();
      e.stopPropagation();
      this.closeDropdown();
      this.changeSellingPlan(option.dataset.planId || null);
      return;
    }
  }

  onDocumentClick() {
    this.closeDropdown();
  }

  toggleDropdown() {
    var dropdown = this.querySelector('.cart-item__subscription-dropdown');
    var select = this.querySelector('.cart-item__subscription-select');
    if (!dropdown || !select) return;
    var isOpen = !dropdown.hidden;
    document.querySelectorAll('cart-item-subscription').forEach(function (el) {
      el.closeDropdown();
    });
    if (!isOpen) {
      dropdown.hidden = false;
      select.classList.add('open');
    }
  }

  closeDropdown() {
    var dropdown = this.querySelector('.cart-item__subscription-dropdown');
    var select = this.querySelector('.cart-item__subscription-select');
    if (dropdown) dropdown.hidden = true;
    if (select) select.classList.remove('open');
  }

  async changeSellingPlan(planId) {
    var sideCart = document.querySelector('side-cart');
    var cartItem = this.closest('.cart-item');
    if (cartItem) cartItem.classList.add('cart-item--loading');

    try {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: this.lineIndex,
          quantity: this.quantity,
          selling_plan: planId ? parseInt(planId) : ''
        })
      });

      if (!planId && this.dataset.variantId) {
        await this.removeLinkedGifts(this.dataset.variantId);
      }
    } catch (err) {
      console.error('[CartItemSubscription] changeSellingPlan error:', err);
    } finally {
      sideCart.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh', { detail: { open: true } })
      );
    }
  }

  async removeLinkedGifts(variantId) {
    try {
      var variantIdStr = String(variantId);
      var cartResponse = await fetch('/cart.js');
      var cartData = await cartResponse.json();
      var updates = {};

      cartData.items.forEach(function (item) {
        var props = Array.isArray(item.properties)
          ? Object.fromEntries(item.properties.map(function (p) { return [p.name, p.value]; }))
          : (item.properties || {});
        var isSubscriptionGift = props._gift === 'true' || props._gift === true;
        var parentVariantMatch = props._parent_variant === variantIdStr;
        var isOtherGiftSystem = props['_is-gift'] || props['_gift-number'];
        if (isSubscriptionGift && parentVariantMatch && !isOtherGiftSystem) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } catch (err) {
      console.error('[CartItemSubscription] removeLinkedGifts error:', err);
    }
  }
}

customElements.define('cart-item-subscription', CartItemSubscription);
